import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import { getFileAction } from '../../redux/actions/UploadAction'
import $ from 'jquery'
import { PanelMrDetail, PanelEvaluation, PanelFine, PanelGRInvoiceDetail } from '../MaterialReceive'
import { UploadButton, UploadList } from "../../components";
import { Input, DatePicker, Select, TextArea } from "../core";
import { Storage, MessageText } from '../../configs'
import utilityHelper from '../../helpers/helperUtil'

import {
    updateMR_DetailAction,
    updateMR_VendorAction,
    updateMR_AttachmentAction,
    updateMR_IrDescriptionAction,
    getMrRefDataAction,
    getMrRefDataVendorAction
} from '../../redux/actions/MRAction'



import {
    getSearchDirectoryInfoAction,

} from '../../redux/actions/MasterAction'
import MasterRedux from "../../redux/reducers/MasterRedux"
import { textAlign } from "@material-ui/system"
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"
import { red } from "@material-ui/core/colors"


class MaterialReceive extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            viewMode: false,
            mrviewMode: false,
            ref_no: '',

            invoicDescription: "",
            transaction_no: null,
            delivery_note: null,
            document_date: null,
            post_date: null,
            local_t_MR_IR_DESCRIPTION: [],
            local_t_GR_DETAIL: {},
            local_t_GR_ITEM: [],
            local_t_GR_SERVICE: []
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeByName = this.handleChangeByName.bind(this)
        this.handleMrRefChange = this.handleMrRefChange.bind(this)


        this.handleCollapse = this.handleCollapse.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        // if (this.props.t_MR_DETAIL.ref_no != null && this.props.t_MR_DETAIL.ref_no!="")
        // {
        //   this.setState({
        //         viewMode: true 
        //     })
        // }
        // else  
        // {
        //     this.setState({
        //         viewMode: false
        //         })
        // }
        this.props.getFile(this.props.transaction_no)  // ดึง ข้อมูลการแนบ file
        this.mrviewMode = this.props.viewMode
        window.onChangeTab = this.onChangeTab.bind(this)

    }
    onChangeTab(tabid) {
        if (tabid === "mr" ||tabid === "gr" || tabid === "ir") {
           
            let { local_t_GR_DETAIL, local_t_GR_ITEM, local_t_GR_SERVICE, local_t_MR_IR_DESCRIPTION } = this.state
            const { t_GR_DETAIL, t_GR_ITEM, t_GR_SERVICE, transaction, viewMode, transaction_no, t_MR_IR_DESCRIPTION } = this.props
            
      

            local_t_MR_IR_DESCRIPTION = this.bindingMrIrDesCroption(t_GR_ITEM, t_GR_SERVICE, local_t_MR_IR_DESCRIPTION, transaction_no, t_GR_DETAIL, t_MR_IR_DESCRIPTION)
            this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
            local_t_GR_SERVICE = t_GR_SERVICE
            this.setState({
                transaction_no: transaction_no,
                viewMode: viewMode,
                delivery_note: t_GR_DETAIL?t_GR_DETAIL.delivery_note:'',
                document_date: t_GR_DETAIL && t_GR_DETAIL.document_date ? moment(t_GR_DETAIL.document_date).format('DD/MM/YYYY') : null,
                post_date: t_GR_DETAIL && t_GR_DETAIL.post_date ? moment(t_GR_DETAIL.post_date).format('DD/MM/YYYY') : null,
                local_t_GR_DETAIL: t_GR_DETAIL,
                local_t_GR_ITEM: t_GR_ITEM,
                local_t_GR_SERVICE: local_t_GR_SERVICE,
                //local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTIONS
                ...this.state.local_t_MR_IR_DESCRIPTION,
                local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTION.map((data, i) => {
                    return data
                })
            })
        }
    }
    
    bindingMrIrDesCroption(t_GR_ITEM, t_GR_SERVICE, local_t_MR_IR_DESCRIPTION, transaction_no, t_GR_DETAIL, t_MR_IR_DESCRIPTION) {
        const grItems = t_GR_ITEM.filter(f => f.checked == 1);
        const grServices = t_GR_SERVICE.filter(f => f.checked == 1);
        let invoicDescription = ""
        let local_t_MR_IR_DESCRIPTIONS = []
        if (grItems != null && grServices != null && grItems.length === 0 && grServices.length === 0) {
            local_t_MR_IR_DESCRIPTION = []
        } else {
            if (typeof grItems != "undefined" && grItems != null && grItems.length != null
                && grItems.length > 0) {
                let mrIrDescLocal = local_t_MR_IR_DESCRIPTION.find(f => f.item_id === null)
                let mrIrDesc = mrIrDescLocal ? mrIrDescLocal : t_MR_IR_DESCRIPTION.find(f => f.item_id === null)
                if (mrIrDesc) {
                    invoicDescription = mrIrDesc.invoic_description
                } else {
                    invoicDescription = t_GR_DETAIL?t_GR_DETAIL.delivery_note:'' //t_GR_DETAIL.delivery_note
                }
                local_t_MR_IR_DESCRIPTIONS.push({ running: 0, transaction_no: transaction_no, item_id: null, short_text: t_GR_DETAIL.po_header_text, invoic_description: invoicDescription })
            }
            if (typeof grServices != "undefined" && grServices != null && grServices.length != null
                && grServices.length > 0) {
                    
                grServices.map((item, index) => {
                    let mrIrDescLocal = local_t_MR_IR_DESCRIPTION.find(f => f.item_id === item.service_item_id && f.transaction_no === item.transaction_no)
                    let mrIrDesc = mrIrDescLocal ? mrIrDescLocal : t_MR_IR_DESCRIPTION.find(f => f.item_id === item.service_item_id && f.transaction_no === item.transaction_no)
                    if (mrIrDesc) {
                        invoicDescription = mrIrDesc.invoic_description
                    } else {
                        invoicDescription = t_GR_DETAIL.reference
                    }
                    invoicDescription = t_GR_DETAIL.reference
                    local_t_MR_IR_DESCRIPTIONS.push({ running: 0, transaction_no: item.transaction_no, item_id: item.service_item_id, short_text: item.short_text, invoic_description: invoicDescription })
                })
            }
        }
        return local_t_MR_IR_DESCRIPTIONS
    } 

    handleMrRefChange(event) {
        // this.setState({
        //     viewMode: true
        // })
        this.handleChange(event)
    }

    handleChange(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? true : false) : target.value;
        //value = target.type === 'radio' ? 'no_evaluation' : value;
        const name = target.name;
        if (name === "invoic_description") {
            let { local_t_MR_IR_DESCRIPTION } = this.state
            if (valid) {
                this.setState({
                    invoicDescription: value,
                    ...this.state.local_t_MR_IR_DESCRIPTION,
                    local_t_MR_IR_DESCRIPTION: local_t_MR_IR_DESCRIPTION.map((data, i) => {
                        if (index === i) {
                            let updateItem = data
                            updateItem[name] = value
                            return updateItem
                        } else {
                            return data
                        }
                    })
                });

                //this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
            }

        } else {
            //check date
            if (target.className.indexOf("js-datepicker") > -1 && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }

            }

            if (name === "ref_no") {
                let { transaction_no } = this.props       
                this.props.getMrRefData(value, transaction_no)
                this.props.getMrRefDataVendor(value, transaction_no)
                this.props.getFile(value)
                if (value != "") {
                    this.setState({
                        viewMode: true,

                    })
                }
                else {
                    this.setState({
                        viewMode: false,

                    })

                }

            }
            if (valid) {
                this.props.updateMR_Detail(value, name)
            } else {
                return
            }
        }
    }

    handleChangeByName(value, name) {
        this.props.updateMR_Detail(value, name)
    }

    async handleChangeVendor(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {
            this.props.updateMR_Vendor(value, index, name)
        } else {
            return
        }
    }

    async handleChangeAttachment(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {
            this.props.updateMR_Attachment(value, index, name)
        } else {
            return
        }
    }
    async handleChangeGRInvoiceDetail(event, index) {
        const value = event.target.value;
        const name = event.target.name;
        const valid = event.target.validity.valid
        let { local_t_MR_IR_DESCRIPTION } = this.state
        await this.setState({
            invoicDescription: value,
            ...this.state.local_t_MR_IR_DESCRIPTION,
            local_t_MR_IR_DESCRIPTION: await local_t_MR_IR_DESCRIPTION.map((data, i) => {
                if (index === i) {
                    let updateItem = data
                    updateItem[name] = value
                    return updateItem
                } else {
                    return data
                }
            })
        });
        if (valid) {
            this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
        }
    }

    handleCollapse() {
        window.$('#collapseItemOverview').toggleClass('show');
        window.$('#collapseItemOverview').focus();

    }

    async handleValidate(event) {
        await this.props.startLoading()
        await this.props.onHandleValidate(event);
    }

    async handleSubmit(event, source, isSubmit,status) {
        //await this.props.mergeMR_Detail();
        //await this.handleValidate(event);
        let { local_t_MR_IR_DESCRIPTION } = this.state
        const { t_MR_IR_DESCRIPTION } = this.props
        if (local_t_MR_IR_DESCRIPTION !== t_MR_IR_DESCRIPTION) {
            this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTION, "", "", true)
        }
        await this.props.onHandleSubmit(event, source, isSubmit,status);
    }

    componentWillReceiveProps(nextProps) {
        //alert ("this.state.transaction_no ==>" + this.state.transaction_no  + " nextProps.transaction_no ==> " + nextProps.transaction_no)
        let { local_t_MR_IR_DESCRIPTION } = this.state
        if (local_t_MR_IR_DESCRIPTION && nextProps.t_MR_IR_DESCRIPTION && local_t_MR_IR_DESCRIPTION.length === 0 && nextProps.t_MR_IR_DESCRIPTION.length > 0 && local_t_MR_IR_DESCRIPTION !== nextProps.t_MR_IR_DESCRIPTION) {
            this.setState({
                //transaction_no: transaction_no,
                viewMode: nextProps.viewMode,
                delivery_note: nextProps.t_GR_DETAIL.delivery_note,
                document_date: nextProps.t_GR_DETAIL.document_date ? moment(nextProps.t_GR_DETAIL.document_date).format('DD/MM/YYYY') : null,
                post_date: nextProps.t_GR_DETAIL.post_date ? moment(nextProps.t_GR_DETAIL.post_date).format('DD/MM/YYYY') : null,
                local_t_GR_DETAIL: nextProps.t_GR_DETAIL,
                local_t_GR_ITEM: nextProps.t_GR_ITEM,
                local_t_GR_SERVICE: nextProps.t_GR_SERVICE,
                ...this.state.local_t_MR_IR_DESCRIPTION,
                local_t_MR_IR_DESCRIPTION: nextProps.t_MR_IR_DESCRIPTION
            })

        }
        if (this.state.transaction_no !== nextProps.transaction_no) {

            if (nextProps.transaction_no) {
                this.props.getFile(nextProps.transaction_no).then((res) => {

                    this.setState({
                        transaction_no: nextProps.transaction_no
                    })
                });

            } else {
                console.log("nextProps.transaction_no is null!")
            }

        }
        var cref_no = this.state.ref_no == null ? '' : this.state.ref_no
        var nref_no = nextProps.t_MR_DETAIL.ref_no == null ? '' : nextProps.t_MR_DETAIL.ref_no
        var nviewMode = false;
        if (cref_no !== nref_no) {
            if (nref_no !== "") {
                this.setState({
                    viewMode: true
                })
                nviewMode = true;
            }
            else {
                this.setState({
                    viewMode: false
                })
                nviewMode = false;
            }
        }

        //check viewmode จาก redux
        if (this.state.viewMode !== nextProps.viewMode) {
            if (nextProps.viewMode !== null && nextProps.viewMode !== "") {
                this.setState({
                    viewMode: nextProps.viewMode || nviewMode
                })
            }
            else {
                this.setState({
                    viewMode: false
                })
            }
        }

    }


    componentDidMount() {
        // console.log("MaterialReceive-componentDidMount()");
        this.onChangeTab("mr")
    }

    async openChooseMethodModal(event) {
        await this.props.startLoading()
        await this.props.onChooseMethod(event);
    }

    openRejectModal() {
        window.$('#RejectWithOptionModal').modal('show');

    }

    async openConfirmModal(event) {  
        const role = Storage.getRole()
        await this.props.startLoading()
        if (role==="C"){
        await this.props.onConfirmModalMethod(event);
        }
        else {
        await this.props.onConfirmVerifyMoalMethod(event);
        }
    }

    render() {
        console.log("MaterialReceive.render()")
        const { local_t_MR_IR_DESCRIPTION, delivery_note, document_date, post_date, viewMode } = this.state
        const { transaction_no, t_PO_DETAIL,t_MR_DETAIL,t_GR_DETAIL,t_MR_IR_DESCRIPTION } = this.props
        const user = Storage.getUser()
        const role = Storage.getRole() 
        const t_HEADER = this.props.t_HEADER;
        
        return (
            <div className="rrs-container-wrap collapse" id="rrsTab5" aria-labelledby="rrsCheck" data-parent="#invoiceRecordingSystem">
                <div className="rrs-container">
                    {/* Start content tab 4 */}
                    {/* 4.1 */}
                    <div className="rrs-detail4">
                        {/*Section1->คณะกรรมการตรวจรับ*/}
                        <PanelMrDetail
                            handleChange={this.handleChange}
                            handleChangeByName={this.handleChangeByName}
                            handleMrRefChange={this.handleMrRefChange}
                            t_MR_DETAIL={t_MR_DETAIL}
                            viewMode={viewMode}
                            viewModeForRefNo={this.props.viewMode}
                        />
                        <PanelGRInvoiceDetail
                            handleChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            local_t_MR_IR_DESCRIPTION={t_MR_IR_DESCRIPTION}
                            t_MR_IR_DESCRIPTION={t_MR_IR_DESCRIPTION}
                            delivery_note={t_GR_DETAIL && t_GR_DETAIL.delivery_note ? t_GR_DETAIL.delivery_note : null}  //{delivery_note}
                            document_date= {t_GR_DETAIL && t_GR_DETAIL.document_date ? moment(t_GR_DETAIL.document_date).format('DD/MM/YYYY') : null}  //{document_date}
                            post_date={t_GR_DETAIL && t_GR_DETAIL.post_date ? moment(t_GR_DETAIL.post_date).format('DD/MM/YYYY') : null} //{post_date}
                            
                        />
                        {/*Section2->แนบเอกสารที่เกี่ยวข้อง*/}
                        <div className="row mt-2 mb-2">
                            <div className="col-lg-12">
                                <div className="sp-header-button-panel2 justify-content-start">
                                    <UploadButton
                                        transaction_no={transaction_no}
                                        modalId={'attachedDocumentNormalModal'}
                                        viewMode={viewMode}
                                        defaultFileName={'เอกสารแนบ'}
                                        file_category={'N'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="sp-table-container">
                            <div className="row no-gutters sp-table-content">

                                <UploadList
                                    key={"uploadlist-mr-" + utilityHelper.genDateKey()}
                                    transaction_no={transaction_no}
                                    file_category={'N'}
                                    viewMode={viewMode}
                                />

                            </div>
                        </div>

                        {/*Section3->ตัวเลือกการประเมิน*/}
                        <PanelEvaluation
                            handleChange={this.handleChange}
                            handleChangeByName={this.handleChangeByName}
                            viewMode={viewMode}
                        />


                        <div className="rrs-form col">

                            <label htmlFor="completed_date" id="#lbl-mr.completed_date" className="rrs-label rrs-label-95">
                                <span className="required">*</span> วันที่ถูกต้องครบถ้วนเมื่อ
                            </label>
                            <div className="rrs-formgroup">
                                <DatePicker
                                    //key={`completed_date${this.props.t_MR_DETAIL.transaction_no}`}
                                    name="completed_date"
                                    id="completed_date"
                                    placeholder="dd/mm/yyyy"
                                    data-date-format="dd/mm/yyyy"
                                    //value={this.props.t_MR_DETAIL.completed_date}
                                    value={t_MR_DETAIL.completed_date
                                        ? moment(t_MR_DETAIL.completed_date).format('DD/MM/YYYY')
                                        : ""}
                                    onChange={this.handleChange}
                                    onBlur={this.handleChange}
                                    doctype="*"
                                    tagid="mr.completed_date"
                                    disabled={viewMode}
                                    viewMode={viewMode}
                                    readOnly={true}
                                // showsdayall={"All"}
                                />
                            </div>
                        </div>


                    </div>
                    {/* 4.2 */}
                    {/*Section4->รายละเอียดค่าปรับ*/}
                    <div className="collapse-box">
                        {/* collapse button 1 */}
                        <div className="showhide-detail-button">
                            <a onClick={this.handleCollapse}
                                className="btn-showhide-detail"
                                data-toggle="collapse"
                                href="#main"
                                role="button"
                                aria-expanded="false"
                                aria-controls="collapseItemOverview">
                                <i className="icon icon-circle-up" /><span> รายละเอียดค่าปรับ</span>
                            </a>
                        </div>
                        <div className="collapse show collapse-onlinereviewer" id="collapseItemOverview">

                            <PanelFine
                                handleChange={this.handleChange}
                                handleChangeByName={this.handleChangeByName}
                                upload_files={this.props.upload_files}
                                t_MR_DETAIL={t_MR_DETAIL}
                                t_HEADER={this.props.t_HEADER}
                                currency={this.props.t_PO_DETAIL.currency}
                                viewMode={viewMode}
                            />

                        </div>
                     
                        {t_PO_DETAIL.po_contract_no != null && this.props.viewMode===false &&  t_PO_DETAIL.status !=='WACCEPT' && (
                            <div className="rrs-detail pt-0">
                                <div className="row sp-table-content-footer" style={{ visibility: "visible" }}>
                                    <div className="col-12 sp-header-button-panel2 justify-content-center">

                                        {/* {this.props.t_MR_DETAIL.transaction_no !== "" && t_HEADER.createBy === user.userName && (
                                            <a className="sp-btn-icon" onClick={() => { this.props.onHandleDelete("Transaction") }}>
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label">Delete</span>
                                            </a>
                                        )} */}
                                        {t_MR_DETAIL.transaction_no !== "" && (t_HEADER.createBy === user.userName || t_HEADER.reviewer_code === user.userName) && (
                                            <a className="sp-btn-icon" onClick={() => { this.props.onHandleDelete("Transaction") }}>
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label2">Delete</span>
                                            </a>
                                        )}
                                        {/* <a  className="sp-btn-icon" onClick={(event) => { this.handleValidate(event) }}>
                                        <i className="icon btn-order-approval" />
                                        <span className="sp-btn-icon-label">Validate</span>
                                    </a> */}

                                        <a href="#main" className="sp-btn-icon" onClick={(event) => { this.handleSubmit(event, this) }}>
                                            <i className="icon btn-order-savedraft" />
                                            <span className="sp-btn-icon-label">Save</span>
                                        </a>

                                        {role == "C" && (
                                            <a className="sp-btn-icon" onClick={(event) => { this.handleSubmit(event, this, true,'WVER') }}>
                                                <i className="icon btn-order-publish" />
                                                <span className="sp-btn-icon-label3">Submit</span>
                                            </a>
                                        )}

                                        {role == "R" && t_MR_DETAIL.transaction_no && (
                                            // <a className="sp-btn-icon btn-choose" onClick={(event) => this.openChooseMethodModal(event)}>
                                            //     <i className="icon btn-order-choose" />
                                            //     <span className="sp-btn-icon-label">Choose Method<br />(RPA or Manually)</span>
                                            // </a>
                                        <a className="sp-btn-icon" onClick={(event) => {this.openConfirmModal(event)}}>
                                            <i className={role==="C"?"icon btn-order-publish":"icon btn-approval-green"} />
                                            <span className="sp-btn-icon-label3">{role==="R"?"Verify":"Submit"}</span>
                                        </a>
                                        )}
                                        {role == "R" && t_MR_DETAIL.transaction_no && t_HEADER.createBy !== user.userName && (
                                            <a className="sp-btn-icon" onClick={() => this.openRejectModal()}>
                                                <i className="icon btn-reject-red" />
                                                <span className="sp-btn-icon-label2" >Not Verify</span>
                                            </a>
                                        )}


                                    </div>
                                    <div className="col-12 sp-header-button-panel2">
                                        <span className="text-remark">
                                            {role == "C" && (<table>
                                                <tr>
                                                    <td>หมายเหตุ:&nbsp;</td>
                                                    <td>-</td>
                                                    <td>เมื่อกดปุ่ม Save ระบบจะทำการตรวจสอบข้อมูลตามเงื่อนไข แต่ยังไม่ส่งข้อมูลให้หน่วยงานจัดหา</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>-</td>
                                                    <td>เมื่อกดปุ่ม Submit ระบบจะทำการตรวจสอบข้อมูล และส่งข้อมูลให้หน่วยงานจัดหาทำการตรวจสอบ</td>
                                                </tr>

                                            </table>)}
                                            {/* {role == "R" &&(<table>
                                                <tr>
                                                    <td>หมายเหตุ:&nbsp;</td>
                                                   
                                                    <td>เมื่อกดปุ่ม Choose Method และยืนยันวิธีการดำเนินการแล้ว ผู้ใช้งานจะไม่สามารถแก้ไขข้อมูลรายการนี้ได้</td>
                                                </tr>

                                            </table>)} */}
                                        </span>

                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* End content tab 4 */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux, MasterRedux } = state
    return {
        transaction_no: MainRedux.transaction_no,
        transaction: MainRedux.transaction,
        t_HEADER: MainRedux.t_HEADER,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
        t_MR_VENDOR: MainRedux.t_MR_VENDOR,
        upload_files: UploadRedux.upload_files,
        //mrDatas:MasterRedux.mrDatas,
        viewMode: MainRedux.viewMode,
        t_GR_DETAIL: MainRedux.t_GR_DETAIL,
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_MR_IR_DESCRIPTION: MainRedux.t_MR_IR_DESCRIPTION,
        mrReason: MasterRedux.mrReason,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        mergeMR_Detail: () => dispatch(updateMR_DetailAction("", "")),
        updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
        updateMR_Vendor: (data, index = "", fieldName = "") => dispatch(updateMR_VendorAction(data, index, fieldName)),
        updateMR_Attachment: (data, index = "", fieldName = "") => dispatch(updateMR_AttachmentAction(data, index, fieldName)),
        updateMR_IrDescription: (data, index = "", fieldName = "", clear = false) => dispatch(updateMR_IrDescriptionAction(data, index, fieldName, clear)),

        getSearchDirectoryInfo: (employeeCode, employeeName) => dispatch(getSearchDirectoryInfoAction(employeeCode, employeeName)),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
        getMrRefData: (transactionNo, otransactionNo) => dispatch(getMrRefDataAction(transactionNo, otransactionNo)),
        getMrRefDataVendor: (transactionNo, otransactionNo) => dispatch(getMrRefDataVendorAction(transactionNo, otransactionNo)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MaterialReceive)